import { FaCalendarCheck, FaEye, FaInfoCircle, FaSpinner, FaTimes } from "react-icons/fa"
import { BACKEND } from "../config/configEnvs"
import { toast } from "react-toastify"
import { useEffect, useState } from "react"
import axios from "axios"
import WebsBoxItemContainer from "../components/proyectos/WebsBoxItemContainer"
import DayBoxItemContainer from "../components/calendarioRevisionesServicios/DayBoxItemContainer"
import { Button, Pagination } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import SearchBarButton from "../components/ui/SearchBarButton"
import Tooltip from "../components/ui/ToolTip"


const RevisionesServicios = () => {

  const [loadingStatus, setLoadingStatus] = useState(false) // Estado de carga de la tabla
   
  const [brandName, setBrandName] = useState("") // Buscador de marcas

  const [page, setPage] = useState(1) // Pagina actual
  const [totalDocs, setTotalDocs] = useState(0) // Total de documentos
  const [totalPages, setTotalPages] = useState(1) // Total de páginas
  const [limit, setLimit] = useState(20) // Límite

  const [month, setMonth] = useState(12) // Mes actual
  const [year, setYear] = useState(2024) // Año actual

  const [agencyWeb, setAgencyWeb] = useState(false)
  const [finished, setFinished] = useState(false)

  const [daysOfMonth, setDaysOfMonth] = useState([]) // Días del mes actual

  const [clients, setClients] = useState([]) // Lista de cliente

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  const programReview = async (day, clientId) => { // Programar revisión
    const date = new Date(Date.UTC(year, month - 1, day, 5, 0, 0));
    const formattedDate = date.toISOString();
    try {
      const response = await axios.post(`${BACKEND}/api/revisionesProgramadasServicios`, {
        client: clientId,
        date: formattedDate
      },
      { withCredentials: true }
      )
      const newReview = response.data.doc;
      setClients((prevClients) =>
        prevClients.map((client) =>
          client.id === clientId
            ? { ...client, reviews: [...client.reviews, newReview] }
            : client
        )
      );
    } catch (error) {
      toast.error("Error al agendar la revisión: " + error)
      console.log(error)
    }
  }

  const deleteReview = async (reviewId) => { // Eliminar revisión
    try {
      await axios.delete(`${BACKEND}/api/revisionesProgramadasServicios/${reviewId}`, { withCredentials: true })

      setClients((prevClients) =>
        prevClients.map((client) => ({
          ...client,
          reviews: client.reviews.filter((review) => review.id !== reviewId),
        }))
      );
    } catch (error) {
      toast.error("Error al eliminar el registro: " + error)
    }
  }

  const getClientReviews = async () => { // Obtenemos los clientes, sus revisiones y servicios
    try {
      setLoadingStatus(true)

      let url = `${BACKEND}/api/qualityReviewsClients/getClientsServicesReviews?month=${month}&year=${year}&page=${page}&limit=${limit}`

      if (brandName) {
        url += `&brandName=${brandName}`
      }

      if (agencyWeb) {
        url += `&activoAgencia=${agencyWeb}`
      }

      if (finished) {
        url += `&finished=${agencyWeb}`
      }

      const response = await axios.get(url, { 
        withCredentials: true,
      })

      setClients(response.data.clients)
      setTotalPages(response.data.totalPages)
      setTotalDocs(response.data.totalDocs)

      setLoadingStatus(false)
    } catch (error) {
      console.log(error)
      toast.error("Error obteniendo las revisiones: " + error)
    }
  }

  const handleSearchClients = () => { // Buscamos clientes y colocamos página 1
    setPage(1)
    getClientReviews()
  }

  const handleResetSearch = () => { // Resetea la búsqueda
    setBrandName(""); // Cambiar el estado
  };

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (brandName === "") {
      getClientReviews(); // Solo se ejecuta cuando se reinicia la búsqueda
      setPage(1); // Reiniciar la paginación si es necesario
    }
  }, [brandName]);

  useEffect(() => {
    // Función para obtener los días del mes con sus nombres
    const getDaysInMonthWithWeekdays = (month, year) => {
      // Obtenemos el número de días en el mes
      const date = new Date(year, month, 0);
      const daysInMonth = date.getDate();
  
      // Creamos un arreglo con todos los días del mes y sus nombres de día de la semana
      const days = [];
      for (let i = 1; i <= daysInMonth; i++) {
        const currentDate = new Date(year, month - 1, i); // Restamos 1 al mes porque los meses son 0 indexados
        const dayOfWeekIndex = currentDate.getDay(); // 0 para domingo, 1 para lunes, etc.
        const dayOfWeekNames = [
          "Domingo",
          "Lunes",
          "Martes",
          "Miércoles",
          "Jueves",
          "Viernes",
          "Sábado",
        ];
  
        days.push({
          day: i, // Día del mes
          weekday: dayOfWeekNames[dayOfWeekIndex], // Nombre del día de la semana
        });
      }
  
      return days;
    };
  
    // Obtenemos el año actual y los días del mes con sus nombres
    const currentYear = new Date().getFullYear();
    const days = getDaysInMonthWithWeekdays(month, currentYear);
    setDaysOfMonth(days); // Aquí se almacena el array de días con nombres
  
  }, [month]);

  useEffect(() => {
    getClientReviews();
  }, [month, year, limit, page, agencyWeb, finished]);

  useEffect(() => {
    getClientReviews();
  }, []);

  return (
    <div className="flex flex-col h-screen w-full">

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 gap-8 bg-gray-100">

        <div className="flex flex-row w-full items-center gap-4 justify-between">
          <div className="flex items-center gap-4 py-4">
            <FaCalendarCheck className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Calendario revisiones de servicios</h2>
          </div>
        </div>

        <div className="flex flex-row items-center justify-center bg-gray-100 gap-8"> 
          <div className="flex flex-row items-center justify-center gap-4">
            <span className="text-xs">Límite</span>
            <select 
              name="limit" 
              id="limit"
              className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              value={limit}
              onChange={(e) => setLimit(e.target.value)}
            >   
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={40}>40</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>

        <SearchBarButton
          brandName={brandName}
          setBrandName={setBrandName}
          handleSearchClients={handleSearchClients}
          handleResetSearch={handleResetSearch}
        />

      </div>

      {/* Activo agencia */}
      <div className="flex flex-row items-center justify-center bg-gray-100 mt-2 mb-2 gap-8">
        
        <div className="flex flex-row items-center justify-center gap-4">
          <span className="text-xs">Mes</span>
          <select 
            name="month" 
            id="month"
            className="text-gray-700 text-xs bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          >   
            <option value={"1"}>Enero</option>
            <option value={"2"}>Febrero</option>
            <option value={"3"}>Marzo</option>
            <option value={"4"}>Abril</option>
            <option value={"5"}>Mayo</option>
            <option value={"6"}>Junio</option>
            <option value={"7"}>Julio</option>
            <option value={"8"}>Agosto</option>
            <option value={"9"}>Septiembre</option>
            <option value={"10"}>Octubre</option>
            <option value={"11"}>Noviembre</option>
            <option value={"12"}>Diciembre</option>
          </select>
        </div>

        <div className="flex flex-row items-center justify-center gap-4">
          <span className="text-xs">Año</span>
          <select 
            name="year" 
            id="year"
            className="text-gray-700 text-xs bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
            value={year}
            onChange={(e) => setYear(e.target.value)}
          >   
            <option value={"2024"}>2024</option>
            <option value={"2025"}>2025</option>
          </select>
        </div>

        <div className="flex flex-row items-center justify-center gap-4">
          <span className="text-xs">Activos Agencia</span>
          <input
            type="checkbox"
            className="rounded-md border-gray-400 hover:cursor-pointer"
            checked={agencyWeb}
            onChange={(e) => setAgencyWeb(e.target.checked)}
          />
        </div>

        <div className="flex flex-row items-center justify-center gap-4">
          <span className="text-xs">Incluir servicios finalizados</span>
          <input
            type="checkbox"
            className="rounded-md border-gray-400 hover:cursor-pointer"
            checked={finished}
            onChange={(e) => setFinished(e.target.checked)}
          />
        </div>

      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
            <div className="flex w-full h-full text-gray-700 items-center justify-center">
              <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                <span>Cargando, por favor espera...</span>
                <FaSpinner className="animate-spin text-gray-500" />
              </div>
            </div>
          ) : (
            clients.length === 0 ? (
              <div className="flex w-full h-full text-gray-700 items-center justify-center">
                <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                    <span>No hay registros</span>
                    <FaInfoCircle className="text-gray-500" />
                </div>
              </div>
            ) : (
              <table className="w-full table-fixed overflow-y-auto">
                <thead className="bg-white sticky top-0 z-50">
                  <tr className="w-full text-gray-700 text-center text-sm uppercase">
                    <td className="w-[260px] text-xs font-bold sticky border border-orange-500 left-0 px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Cliente
                    </td>
                    {daysOfMonth.map((day, index) => (
                        <td
                          key={index}
                          className="px-3 py-3 w-[200px] text-center text-xs font-bold bg-[#FE6400] border-r border-r-white text-white border-red"
                        >
                          <div>{`${day.weekday} ${day.day}`}</div>
                        </td>
                      ))
                    }
                  </tr>
                </thead>
                <tbody>
                  {clients.map((client) => (
                    <tr
                      key={client.id}
                      className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300"
                    >
                      <td 
                        scope="row" 
                        className="w-[5%] sticky bg-white border text-xs border-gray-300 left-0 py-2 max-w-xs border border-gray-300 text-center transition-all duration-100 font-semibold"
                      >
                        <div className="flex flex-row items-center justify-center gap-2">

                          <span className="hover:cursor-pointer hover:underline">
                            {client.nombreComercial}
                          </span>

                          <Tooltip 
                            content={
                              <div>
                                <span className="text-[10px] text-white font-semibold">Servicios en proceso: </span>
                                <span className="text-[10px] text-white font-light justify-center text-white">
                                  {client.services.join(" - ")}
                                </span>
                              </div>
                            }
                          >
                            <div className="flex items-center justify-center hover:text-orange-500 transition-all duration-100 hover:cursor-pointer">
                              <FaEye />
                            </div>
                          </Tooltip>


                        </div>
                      </td>
                      {daysOfMonth.map((day, index) => (
                          <DayBoxItemContainer 
                            key={index} 
                            reviews={client.reviews}
                            day={day.day}
                            programReview={programReview}
                            deleteReview={deleteReview}
                            client={client}
                          />
                        ))
                      }
                    </tr>
                  ))}

                </tbody>
              </table>
            )
          )
        }
      </div>

      {/* Paginador */}
      <div className="w-full flex flex-col gap-4 py-4 justify-center items-center ">
        <span className="text-sm text-gray-700 dark:text-gray-500 ">
          Mostrando
          <span className="font-semibold text-gray-900 dark:text-gray-300 ">
            {" "}
            {clients.length}
          </span>{" "}
          de
          <span className="font-semibold text-gray-900 dark:text-gray-300 ">
            {" "}
            {totalDocs}
          </span>{" "}
          clientes
        </span>
        <Pagination
          count={totalPages}
          page={page}
          variant="outlined" 
          shape="rounded"
          onChange={handlePageChange}
        />
      </div>

    </div>
  )
}

export default RevisionesServicios